import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { postgraduatePromoBannerLenovo } from 'src/assets/images'
import AccentBox from 'src/components/PostGraduationContent/PostgraduateComponents/AccentBox/AccentBox'
import CustomTable from 'src/components/PostGraduationContent/PostgraduateComponents/Table/CustomTable'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduateResults2022.styles'

const PostGraduateResultsContent = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  const data = [
    { name: 'AMARILDO MAIA ROLIM FILHO' },
    { name: 'ANA PAULA ASSIS BUOSI' },
    { name: 'ANNE CAROLINE RODRIGUES PEREIRA' },
    { name: 'DANIEL DE MOURA CRUZ' },
    { name: 'DANIEL REZENDE DE BARROS' },
    { name: 'ELDER CORDEIRO' },
    { name: 'JOSE ALEXSANDRO DO NASCIMENTO SILVA' },
    { name: 'MARIA EDUARDA DE SOUSA VIRIATO' },
    { name: 'SASKYA ALVES PIMENTA' },
    { name: 'VALDECLEBIO FARRAPO COSTA' },
    { name: 'WALLISSON FREITAS DE SOUZA' }
  ]

  return (
    <Box className={globalClasses.containerPages}>
      <BreadcrumbsComponent
        crumbs={[
          { label: t('navbar.start'), path: '/' },
          { label: t('navbar.postgraduate'), path: '/postgraduate' },
          {
            label: 'Residência em Segurança Cibernética 2022',
            path: '/postgraduate/rsc-2022'
          },
          {
            label: t('news.postgraduate.sub.results.page-title')
          }
        ]}
      />
      <Box className={classes.container}>
        <Typography className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.sub.results.page-title')}
        </Typography>
        <Box className={classes.contentWrapper}>
          <img
            className={classes.promoImg}
            src={postgraduatePromoBannerLenovo}
            alt="Banner"
          />
          <Box className={classes.contentContainer}>
            <Typography className={globalClasses.titleSectionVariant2}>
              Classificação do Processo Seletivo
            </Typography>
            <Typography className={classes.paragraph}>
              A comissão de seleção do processo seletivo da Residência em
              Segurança Cibernética Edital nº 01/2022 divulga hoje, dia 6 de
              maio de 2022, a lista definitiva dos selecionados. Confira abaixo:
            </Typography>
            <Typography className={globalClasses.titleSectionVariant2}>
              {t('news.postgraduate.sub.results.table.title4')}
            </Typography>
            <Typography className={classes.tableSubtitle}>
              {t('news.postgraduate.sub.results.table.subtitle')}
            </Typography>
            <Box className={classes.tableContainer}>
              <CustomTable
                headers={[t('news.postgraduate.sub.results.table.name')]}
                rows={data.map((person) => [person.name])}
              />
            </Box>
            <Box className={classes.separator} />
            <Typography className={globalClasses.titleSectionVariant2}>
              {t('news.postgraduate.sub.contact')}
            </Typography>
            <AccentBox email="rsc@lsbd.ufc.br" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduateResultsContent
